import React from 'react'

import styles from './privacySidebar.module.scss'

const PrivacySidebar = () => {
  return (
    <aside className={styles.privacySidebar}>
      <ul>
        <li>
          <a href="#privacy-policy">Privacy policy</a>
        </li>
        <li>
          <a href="#categories-of-personal-information">Categories of personal information</a>
        </li>
        <li>
          <a href="#purpose-for-collection-use">Purposes for collection/use</a>
        </li>
        <li>
          <a href="#sources-of-personal-information">Sources of personal information</a>
        </li>
        <li>
          <a href="#categories-of-information-shared-with-third-parties-and-categories-of-3rd-parties">
            Categories of information shared with third parties and categories of 3rd parties
          </a>
        </li>
        <li>
          <a href="#how-to-exercise-consumer-rights-appeal-right-contacts">
            How to exercise consumer rights, appeal rights, contacts
          </a>
        </li>
        <li>
          <a href="#cookies">Cookies</a>
        </li>
        <li>
          <a href="#third-party-cookies">Third-Party cookies</a>
        </li>
      </ul>
    </aside>
  )
}

export { PrivacySidebar }
